import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import NavBarContext from '../navBarContext';
import AccountInfo from './AccountInfo';
import LoginMenu from './LoginMenu';

function AccountMenu() {
  const { profile, isAuthenticated, logout } = useContext(NavBarContext);
  const history = useHistory();
  return isAuthenticated ? (
    <AccountInfo profile={profile} logout={logout} history={history} />
  ) : (
    <LoginMenu />
  );
}

export default AccountMenu;
